const { apiRequest } = require('api/apiClient');

const fetchParentProducts = async ({ page, pageSize, search, ordering, filters }) => {
  const response = await apiRequest('GET', '/v1/parent-products', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { name: search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchChildProducts = async ({ page, pageSize, search, ordering, filters }) => {
  const response = await apiRequest('GET', '/v1/child-products', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchAllChildProducts = async ({ page, pageSize, search, ordering, filters }) => {
  const response = await apiRequest('GET', '/v1/child-products', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchProductColors = async ({ page, pageSize, search, ordering, filters }) => {
  const response = await apiRequest('GET', '/v1/product-colors', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchProductSizes = async ({ page, pageSize, search, ordering, filters }) => {
  const response = await apiRequest('GET', '/v1/product-sizes', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchProductCategories = async ({ page, pageSize, search, ordering, filters }) => {
  const response = await apiRequest('GET', '/v1/product-categories', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchProductInventories = async ({ page, pageSize, search, ordering, filters }) => {
  const response = await apiRequest('GET', '/v1/product-inventories', null, {
    params: {
      ...(page ? { page } : {}),
      ...(pageSize ? { page_size: pageSize } : {}),
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchFavoriteProducts = async () => {
  const response = await apiRequest('GET', '/v1/favorite-products', null);
  return response;
};

const PRODUCTS_QUERIES = {
  FETCH_PARENT_PRODUCTS: fetchParentProducts,
  FETCH_CHILD_PRODUCTS: fetchChildProducts,
  FETCH_ALL_CHILD_PRODUCTS: fetchAllChildProducts,
  FETCH_PRODUCT_COLORS: fetchProductColors,
  FETCH_PRODUCT_SIZES: fetchProductSizes,
  FETCH_PRODUCT_CATEGORIES: fetchProductCategories,
  FETCH_PRODUCT_INVENTORIES: fetchProductInventories,
  FETCH_FAVORITE_PRODUCTS: fetchFavoriteProducts,
};

export default PRODUCTS_QUERIES;
